import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BorrowerStatusDisplaySmartComponent } from './borrower-status-display-smart/borrower-status-display-smart.component';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { BorrowerStatusPickerModule } from '../borrower-status-picker/borrower-status-picker.module';
import { LetDirectiveModule } from 'ng2-app/modules/directives/let/let.directive.module';

@NgModule({
  declarations: [
    BorrowerStatusDisplaySmartComponent
  ],
  imports: [
    BorrowerStatusPickerModule,
    CommonModule,
    LetDirectiveModule,
    MatButtonModule,
    MatSelectModule,
  ],
  exports: [
    BorrowerStatusDisplaySmartComponent
  ]
})
export class BorrowerStatusDisplayModule { }
